import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  relative: { position: 'relative' },
  addAllToCartButtonContainer: {
    pointerEvents: 'none',
    position: 'sticky',
    bottom: 85,
    right: 0,
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.down('lg')]: {
      bottom: theme.spacing(2),
    },
  },
  addAllToCartButton: {
    paddingInline: '20px',
    pointerEvents: 'auto',
  },
}));
